"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDeliveryRpcRemote = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const logger = new utils_1.Logger(module);
class ContentDeliveryRpcRemote extends dht_1.RpcRemote {
    rtt;
    async sendStreamMessage(msg, doNotBufferWhileConnecting) {
        const options = this.formDhtRpcOptions({
            notification: true,
            doNotBufferWhileConnecting
        });
        this.getClient().sendStreamMessage(msg, options).catch(() => {
            logger.trace('Failed to sendStreamMessage');
        });
    }
    leaveStreamPartNotice(streamPartId, isLocalNodeEntryPoint) {
        const notification = {
            streamPartId,
            isEntryPoint: isLocalNodeEntryPoint
        };
        const options = this.formDhtRpcOptions({
            notification: true
        });
        this.getClient().leaveStreamPartNotice(notification, options).catch(() => {
            logger.debug('Failed to send leaveStreamPartNotice');
        });
    }
    setRtt(rtt) {
        this.rtt = rtt;
    }
    getRtt() {
        return this.rtt;
    }
}
exports.ContentDeliveryRpcRemote = ContentDeliveryRpcRemote;
//# sourceMappingURL=ContentDeliveryRpcRemote.js.map